import { fetcher } from '@commenda/utils';
import type { AdminSlackChannelSummary } from './useAdminCompanyExternalConnections';

export interface SearchAdminSlackChannelsParams {
  query: string;
}

export async function searchAdminSlackChannels({
  query,
}: SearchAdminSlackChannelsParams): Promise<AdminSlackChannelSummary[]> {
  const params = new URLSearchParams({ query });

  const response = await fetcher(
    `admin/external-connections/slack/channels?${params.toString()}`,
    { method: 'GET' }
  );

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as {
      message?: unknown;
      error?: unknown;
    } | null;
    const message =
      typeof body?.message === 'string'
        ? body.message
        : Array.isArray(body?.message)
          ? body.message.join(', ')
          : typeof body?.error === 'string'
            ? body.error
            : 'Failed to search Slack channels';
    throw new Error(message);
  }

  return response.json();
}
